import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center bg-white pt-20 overflow-hidden"
    >
      {/* Gradient blobs */}
      <div className="blob-pink" style={{ top: '-10%', right: '-5%' }} />
      <div className="blob-blue" style={{ bottom: '5%', left: '-8%' }} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="animate-fade-in-up mb-10" style={{ opacity: 0, animationDelay: '0.1s' }}>
          <span
            className="inline-flex items-center border-2 border-[#0A0A0A] px-5 py-2 text-xs uppercase tracking-[0.15em] text-[#0A0A0A] font-black bg-white"
            style={{ fontFamily: "'Satoshi', sans-serif" }}
          >
            School Management System
          </span>
        </div>

        {/* Main Heading */}
        <h1
          className="text-6xl sm:text-7xl lg:text-[7rem] font-black uppercase leading-[0.85] tracking-tighter text-[#0A0A0A] mb-8 animate-fade-in-up"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif", opacity: 0, animationDelay: '0.2s' }}
          data-testid="hero-heading"
        >
          Manage Your
          <br />
          School With
          <br />
          <span className="text-gray-300">Ease</span>
        </h1>

        {/* Subtext */}
        <p
          className="text-base lg:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed mb-10 animate-fade-in-up font-medium"
          style={{ fontFamily: "'Satoshi', sans-serif", opacity: 0, animationDelay: '0.4s' }}
          data-testid="hero-subtext"
        >
          Enterprise-grade school management system built for Ghanaian schools.
          Manage students, staff, finances, and academics — all in one place.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14 animate-fade-in-up" style={{ opacity: 0, animationDelay: '0.5s' }}>
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] hover:bg-[#1a1a1a] text-white font-black px-10 py-4 text-sm uppercase tracking-wider transition-all duration-200 group"
            style={{ fontFamily: "'Satoshi', sans-serif" }}
          >
            Request Custom Proposal
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" strokeWidth={3} />
          </a>
          <a
            href="#features"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center justify-center gap-2 border-2 border-gray-200 hover:border-[#0A0A0A] text-[#0A0A0A] bg-white px-10 py-4 text-sm uppercase tracking-wider transition-all duration-200 font-black"
            style={{ fontFamily: "'Satoshi', sans-serif" }}
          >
            Explore Features
          </a>
        </div>

        {/* Trust */}
        <div className="animate-fade-in-up" style={{ opacity: 0, animationDelay: '0.6s' }}>
          <p className="text-xs text-gray-400 uppercase tracking-[0.15em] mb-6 font-bold" style={{ fontFamily: "'Satoshi', sans-serif" }}>
            Trusted by schools across Ghana
          </p>
          <div className="flex items-center justify-center gap-8 flex-wrap">
            {["Achimota School", "Prempeh College", "Wesley Girls", "Mfantsipim"].map((school) => (
              <span
                key={school}
                className="text-sm font-black text-gray-300 uppercase tracking-wider"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {school}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
